import { z } from 'zod';
import { baseTotalSchema, currencyBalanceSchema } from './accounts.js';
import { currencyCodeSchema } from './currency.js';
import { moneyAmountSchema } from './money.js';
/**
 * Totals for the viewer, computed by PostgreSQL from postings. Only accounts and transactions
 * the viewer can see are counted.
 */
export const balanceSummarySchema = z.object({
    /** The family's base currency: `total`, `shared`, members' `total` and `month` are in it. */
    currency: currencyCodeSchema,
    /**
     * All visible money accounts (cards count as negative when money is owed), in base currency.
     * Other currencies are converted at the latest family rate: see `estimated`.
     */
    total: moneyAmountSchema,
    /** The same per currency, base currency first. */
    totalByCurrency: z.array(currencyBalanceSchema),
    /** True when some balances were converted at the latest rate (the totals are estimates). */
    estimated: z.boolean(),
    /** Currencies with money but no family rate yet: left out of the base-currency totals. */
    missingRates: z.array(currencyCodeSchema),
    /** Visible shared family accounts. */
    shared: moneyAmountSchema,
    sharedByCurrency: z.array(currencyBalanceSchema),
    members: z.array(z.object({
        memberId: z.string().uuid(),
        displayName: z.string(),
        total: moneyAmountSchema,
        byCurrency: z.array(currencyBalanceSchema),
    })),
    month: z.object({
        /** First and last day of the current month in the family's time zone (YYYY-MM-DD). */
        from: z.string(),
        to: z.string(),
        /** In base currency, from each transaction's own snapshot rate: past months never move. */
        income: moneyAmountSchema,
        expense: moneyAmountSchema,
    }),
    /**
     * Net worth of what the viewer can see (Phase 4): money accounts plus money owed to us minus
     * money we owe, per currency, and in base currency (≈ when it mixes currencies). A debt between
     * two members cancels out when both sides are visible.
     */
    netWorth: z.object({
        byCurrency: z.array(currencyBalanceSchema),
        inBase: baseTotalSchema,
    }),
});
//# sourceMappingURL=balances.js.map